import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as employeeApi from '../../lib/api/employee';


const [LIST_EMPLOYEES, LIST_EMPLOYEES_SUCCESS, LIST_EMPLOYEES_FAILURE] =
  createRequestActionTypes('employee/LIST_EMPLOYEES');
export const listEmployees = createAction(
  LIST_EMPLOYEES,
  (searchData) => searchData,
);
const listEmployeesSaga = createRequestSaga(
  LIST_EMPLOYEES,
  employeeApi.getEmployees,
);

const UNLOAD_EMPLOYEES = 'employee/UNLOAD_EMPLOYEES';
export const unloadEmployees = createAction(UNLOAD_EMPLOYEES);

export function* employeesSaga() {
  
  yield takeLatest(LIST_EMPLOYEES, listEmployeesSaga);
}

const initialState = {
  employees: null,
  error: null,
};

const employees = handleActions(
  {
   
    [LIST_EMPLOYEES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      employees: data.list.map((employee) => ({
        id: employee.usrUuid,
        usrUuid: employee.usrUuid,
        usrNo:employee.usrNo,
        usrNm: employee.usrNm,
        emlAddr: employee.emlAddr,
        telNo: employee.telNo,
        price: employee.price,
        infoDesc: employee.infoDesc,
        postAddrTxt:employee.postAddrTxt,
        postAddrNm:employee.postAddrNm,
        entryDt:employee.entryDt,
        dptUuid:employee.dptUuid,
        dptNm:employee.dptNm,
        gradeUuid:employee.gradeUuid,
        gradeNm:employee.gradeNm,
        profileImg:employee.profileImg,
        gender:employee.gender,
        useYn: employee.useYn === 'Y' ? true : false,
        crtNm: employee.crtNm,
        crtDt: employee.crtDt,
        cngNm: employee.cngNm,
        cngDt: employee.cngDt,
      })),
      error: null,
    }),
    [LIST_EMPLOYEES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_EMPLOYEES]: ()=> initialState
  },
  initialState,
);

export default employees;
